import React from "react";

import { theme } from "styles/theme";
import { Icon } from "../../Icon";
import { Input } from "../../Input";

import { InputFieldProps } from "../types";
import { ClearButton, InputFieldWrapper } from "./styles";

/**
 * Componente InputField (Desktop)
 *
 * Combinação do campo de entrada com funcionalidades adicionais, como botão de limpeza.
 *
 * @param {string} [placeholder='Search...'] - Texto exibido como placeholder.
 * @param {string} value - Valor atual do campo.
 * @param {(e: React.ChangeEvent<HTMLInputElement>) => void} onChange - Callback executado ao alterar o valor do campo.
 * @param {() => void} [onFocus] - Callback executado ao focar no campo.
 * @param {() => void} [onClear] - Callback executado ao clicar no botão de limpar.
 * @param {boolean} [showClearButton=true] - Define se o botão de limpeza será exibido.
 * @param {string} [iconColor] - Cor do ícone no campo.
 */
export const InputField: React.FC<InputFieldProps> = ({
  placeholder = "Search...",
  value,
  onChange,
  onFocus,
  onClear,
  showClearButton = true,
  iconColor,
  ref = null,
}) => (
  <InputFieldWrapper>
    <Input
      backgroundColor={theme.colors.transparent}
      borderColor={theme.colors.transparent}
      placeholder={placeholder}
      textColor={iconColor}
      onChange={onChange}
      onFocus={onFocus}
      value={value}
      size="large"
      ref={ref}
    />
    {showClearButton && value && (
      <ClearButton onClick={onClear} aria-label="Clear input">
        <Icon
          library="md"
          name="MdOutlineClose"
          color="primary.mediumBlue"
          size="small"
        />
      </ClearButton>
    )}
  </InputFieldWrapper>
);
